import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('manage-privilage/index', {params});
    },
    getPrivilege(params) {
        return Service().get('manage-privilage/get-privilege', {params});
    },
    show(id) {
        return Service().get('manage-privilage/show/'+id);
    },
    create(params) {
        return Service().post('manage-privilage/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('manage-privilage/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    duplicate(params) {
        return Service().post('manage-privilage/duplicate', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('manage-privilage/delete/'+id);
    },
}